import * as ActionTypes from "./reward.type";

const initialState = {
  referral: [],
  engagement: [],
  reward: [],
  totalRewards: null,
  engagementType: [
    "VIDEO_WATCH",
    "VIDEO_LIKE",
    "VIDEO_COMMENT",
    "VIDEO_DISLIKE",
  ],
};

export const rewardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_REFERRAL:
      return {
        ...state,
        referral: action.payload,
      };
    case ActionTypes.ADD_REFERRAL:
      return {
        ...state,
        referral: action.payload,
      };
    case ActionTypes.EDIT_REFERRAL:
      return {
        ...state,
        referral: action.payload,
      };
    case ActionTypes.DELETE_REFERRAL:
      return {
        ...state,
        referral: null,
      };
    case ActionTypes.GET_ENGAGEMENT:
      const engagementFetched = action.payload.map((item) => item.type);
      const engagementRemaining = state.engagementType.filter(
        (type) => !engagementFetched.includes(type),
      );
      return {
        ...state,
        engagement: action.payload,
        engagementType: engagementRemaining,
      };
    case ActionTypes.ADD_ENGAGEMENT:
      const engagementLeft = state.engagementType.filter(
        (item) => item !== action.payload.type,
      );
      return {
        ...state,
        engagement: [...state.engagement, action.payload],
        engagementType: engagementLeft,
      };
    case ActionTypes.EDIT_ENGAGEMENT:
      return {
        ...state,
        engagement: state.engagement.map((item) => {
          if (item._id === action.payload.data._id) {
            return { ...action.payload.data };
          }
          return item;
        }),
      };
    case ActionTypes.DELETE_ENGAGEMENT:
      const engagementAdded = action.payload.type;
      return {
        ...state,
        engagement: state.engagement.filter(
          (engagement) => engagement._id !== action.payload._id,
        ),
        engagementType: [...state.engagementType, engagementAdded],
      };
    case ActionTypes.GET_ADVERTISMENT:
      return {
        ...state,
        reward: action.payload,
        totalRewards: action.payload?.length || 0,
      };
    case ActionTypes.ADD_ADVERTISMENT:
      return {
        ...state,
        reward: [...state.reward, action.payload],
        totalRewards: state.totalRewards + 1,
      };
    case ActionTypes.EDIT_ADVERTISMENT:
      const updatedReward = state.reward.map((item) => {
        if (item._id === action.payload.rewardId) {
          return {
            ...action.payload.data,
          };
        }
        return item;
      });
      return {
        ...state,
        reward: updatedReward,
      };
    case ActionTypes.DELETE_ADVERTISMENT:
      return {
        ...state,
        reward: state.reward.filter((reward) => reward._id !== action.payload),
      };
    default:
      return state;
  }
};
